import { render, staticRenderFns } from "./WebStoreRewardPoint.vue?vue&type=template&id=39d27db6&"
import script from "./WebStoreRewardPoint.vue?vue&type=script&lang=js&"
export * from "./WebStoreRewardPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports